export const DEVELOPMENT = "development";
export const DEV = "dev";
export const TESTBED = "testbed";
export const PRODUCTION = "production";

type NodeEnvironment = "development" | "test" | "production";

function isValidNodeEnvironment(
  env: string | undefined
): env is NodeEnvironment {
  return [DEVELOPMENT, "test", PRODUCTION].includes(env || "");
}

function isNotProductionEnvironment(nodeEnv: NodeEnvironment) {
  return nodeEnv !== PRODUCTION;
}

// 운영·테스트베드는 명시된 값으로만 판정한다(allowlist).
// 과거에는 default가 PRODUCTION이라 NEXT_PUBLIC_MY_ENVIRONMENT를 주입하지 않은 로컬
// prod 빌드(next build && next start)가 production으로 태깅돼 운영 Sentry로 흘러들었다.
// Jenkins는 production/testbed/development를 항상 명시 주입하므로 배포 판정은 불변이고,
// 값이 없거나 알 수 없는 값(local 등)은 이제 운영으로 승격되지 않는다.
export function getCustomEnvironment(myEnvironment = "") {
  switch (myEnvironment) {
    case PRODUCTION:
      return PRODUCTION;
    case TESTBED:
      return TESTBED;
    default:
      return DEV;
  }
}

export function determineEnvironment() {
  let nodeEnv: NodeEnvironment = DEVELOPMENT; // Default value
  if (isValidNodeEnvironment(process.env.NODE_ENV)) {
    nodeEnv = process.env.NODE_ENV;
  }

  // 폴백은 getCustomEnvironment의 기본 매개변수(빈 문자열 → DEV)에 맡긴다.
  // 과거의 `|| DEV`는 DEV("dev")가 getCustomEnvironment의 어느 case에도 걸리지 않아
  // default(PRODUCTION)로 떨어지는 죽은 폴백이었다.
  const myEnvironment = process.env.NEXT_PUBLIC_MY_ENVIRONMENT;

  if (isNotProductionEnvironment(nodeEnv)) {
    return DEVELOPMENT;
  }

  return getCustomEnvironment(myEnvironment);
}
